<smp-dropzone class="full-width"
              [idPrefix]="(idPrefix + smpFileCategory + '.dropzone.')"
              [label]="dropzoneLabel"
              [acceptedFiles]="acceptedFiles"
              [addButtonLabel]="addButtonLabel"
              [hasContent]="hasContent"
              (filesSelected)="onFilesSelected($event)">
    <ng-content></ng-content>
</smp-dropzone>
